export default __webpack_public_path__ + "static/media/ensvee-logo-white.6659ea4a.svg";